import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "filter"]
  static values = { storageKey: String }

  connect() {
    const saved = this.loadState()

    this.filterTargets.forEach(filterEl => {
      const name = filterEl.dataset.filterName
      const hasValue = this.filterHasValue(filterEl)
      const visible = hasValue || saved.includes(name)

      this.setFilterVisible(filterEl, visible)
      this.syncCheckbox(name, visible)
    })
  }

  toggle(event) {
    const name = event.target.dataset.filterName
    const visible = event.target.checked
    const filterEl = this.filterTargets.find(el => el.dataset.filterName === name)
    if (!filterEl) return

    this.setFilterVisible(filterEl, visible)

    if (!visible) {
      // Clear inputs and submit to remove filter from results
      this.clearFilterInputs(filterEl)
      this.saveState()
      const form = this.element.closest("form") || this.element.querySelector("form")
      if (form) form.requestSubmit()
    } else {
      this.saveState()
    }
  }

  // --- Helpers ---

  setFilterVisible(el, visible) {
    el.classList.toggle("d-none", !visible)
  }

  syncCheckbox(name, checked) {
    const cb = this.checkboxTargets.find(el => el.dataset.filterName === name)
    if (cb) cb.checked = checked
  }

  filterHasValue(filterEl) {
    const inputs = filterEl.querySelectorAll("input, select")
    return Array.from(inputs).some(input => {
      if (input.tagName === "SELECT") return input.value !== ""
      return input.value !== ""
    })
  }

  clearFilterInputs(filterEl) {
    filterEl.querySelectorAll("input, select").forEach(input => {
      if (input.tagName === "SELECT") {
        input.value = ""
      } else {
        input.value = ""
      }
    })
  }

  loadState() {
    if (!this.storageKeyValue) return []
    try {
      return JSON.parse(localStorage.getItem(this.storageKeyValue)) || []
    } catch {
      return []
    }
  }

  saveState() {
    if (!this.storageKeyValue) return
    const visible = this.filterTargets
      .filter(el => !el.classList.contains("d-none"))
      .map(el => el.dataset.filterName)
    localStorage.setItem(this.storageKeyValue, JSON.stringify(visible))
  }
}
